exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.real_task_wrap{width:100%;height:100%;background:#F4F4F4;padding:16px;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n", "", {"version":3,"sources":["/data/data/jenkins/workspace/edu-gxzx-web-pro-new-study/src/components/views/studyCenter/switch/realTask/index.vue"],"names":[],"mappings":";AA8BA,gBACE,WACA,YACA,mBACA,aACA,8BAAA,qBAAsB;CACvB","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.real_task_wrap{\n  width: 100%;\n  height: 100%;\n  background: #F4F4F4;\n  padding: 16px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40ae90a2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/studyCenter/switch/realTask/index.vue
// module id = bQc9
// module chunks = 96